module.exports = __webpack_public_path__ + "linea-software-10.b5b4a545328f3eee2789.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-software-10.eot
// module id = ../../../../../src/assets/linea/fonts/linea-software-10.eot
// module chunks = styles